import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NbCalendarRange } from '@nebular/theme';

export interface Attendance {
  date: string;
  workingStatus: string;
}

export interface LeaveRequest {
  leaveType: any;
  startDate: Date;
  endDate: Date;
  reason: string;
  prompt: string;
  fileBinary: string | null;
  fileName: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  private attendanceData = new BehaviorSubject<Attendance[]>([]);
  attendanceData$ = this.attendanceData.asObservable();

  private selectedDates = new BehaviorSubject<string[]>([]);
  selectedDates$ = this.selectedDates.asObservable();

  private typeSubject = new BehaviorSubject<string>('none');
  type$ = this.typeSubject.asObservable();

  private leaveRange = new BehaviorSubject<NbCalendarRange<Date> | null>(null);
  leaveRange$ = this.leaveRange.asObservable();

  // ✅ ADD THIS (hover preview support)
  private hoverDate = new BehaviorSubject<Date | null>(null);
  hoverDate$ = this.hoverDate.asObservable();

  constructor(private http: HttpClient) {}

  setType(type: string) {
    this.typeSubject.next(type);
  }

  get currentType() {
    return this.typeSubject.value;
  }

  setAttendanceData(data: Attendance[]) {
    this.attendanceData.next(data);
  }

  setSelectedDates(dates: string[]) {
    this.selectedDates.next([...dates]);
  }

  toggleDateSelection(date: string) {
    const currentSelection = this.selectedDates.getValue();
    const index = currentSelection.indexOf(date);

    if (index === -1) {
      this.selectedDates.next([...currentSelection, date]);
    } else {
      currentSelection.splice(index, 1);
      this.selectedDates.next([...currentSelection]);
    }
  }

  getSelectedDates(): string[] {
    return this.selectedDates.getValue();
  }

  setLeaveRange(range: NbCalendarRange<Date> | null) {
    this.leaveRange.next(range);
  }

  getLeaveRange(): NbCalendarRange<Date> | null {
    return this.leaveRange.getValue();
  }

  // ✅ ADD THESE METHODS (hover control)
  setHoverDate(date: Date | null) {
    this.hoverDate.next(date);
  }

  getHoverDate(): Date | null {
    return this.hoverDate.getValue();
  }
}
